import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import RelatedDataForm from './RelatedDataForm';

import { REVIEW_YEAR_1, REVIEW_YEAR_2, REVIEW_YEAR_3 } from '../../fastConstants';

export default function RelatedDataDialog(props) {
    const [programId, setProgramId] = useState()

    const handleClose = () => {
        props.handleCloseDialog()
    }

    const handleCancel = () => {
        props.handleCancelDialog()
    }

    let allPrograms = props.programs;
    let programs = []
    if (programId) {
        let prog = allPrograms.find(element => element.id == programId);
        if (prog) {
            programs.push(prog)
        }
    }

    if (programs?.length == 0) {
        programs = [...allPrograms]
    }
    
    let selectedProgramId = props.programId
    if (programId) {
        selectedProgramId = programId
    }
    
    let yearOneData = {}
    let yearTwoData = {}
    let yearThreeData = {}
    
    if (props.programDataCache) {
        let programData = props.programDataCache[selectedProgramId]
        if (programData && REVIEW_YEAR_1 in programData) {
            yearOneData = programData[REVIEW_YEAR_1]
        }
        
        if (programData && REVIEW_YEAR_2 in programData) {
            yearTwoData = programData[REVIEW_YEAR_2]
        }
        
        if (programData && REVIEW_YEAR_3 in programData) {
            yearThreeData = programData[REVIEW_YEAR_3]
        }
    }

    return (
        <Modal size="lg" show={props.showModal} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Related Data - Info</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="text-center">
                    <h2>Related Data</h2>
                    <div className="p-3">
                        The data on this table relates to the indicated program 
                        and the courses taken by most (&gt; 90%) graduates from the 
                        program. Some of these data may lead to questions related 
                        to the learning outcomes being assessed, which may be 
                        useful when identifying focus areas.
                    </div>
                    
                </div>
                <div className="text-center">
                    <Form.Group as={Row} className="mb-3" controlId="formDepartment">
                        <Form.Label column="lg" sm="4">
                            Department
                        </Form.Label>
                        <Form.Label column="lg" sm="8" className="text-muted">
                            { props.department?.name }
                        </Form.Label>
                    </Form.Group>
                </div>
                <div className="text-center">
                    <Form.Group as={Row} className="mb-3" controlId="formProgram">
                        <Form.Label column="lg" sm="4">
                            Program
                        </Form.Label>
                        <Col
                            column="lg"
                            sm="8"
                            >
                            <Form.Select 
                                aria-label="Select Program" 
                                onChange={props.onProgramChanged}
                                value={selectedProgramId}
                                >
                                {
                                    programs.map((program,key) => 
                                        <option key={key} value={program.programId}>{program.name}</option>
                                    )
                                }
                            </Form.Select>
                            
                        </Col>
                    </Form.Group>
                </div>
                <div className="m-5">
                    <RelatedDataForm
                        yearOneData={yearOneData}
                        yearTwoData={yearTwoData}
                        yearThreeData={yearThreeData}
                        />
                </div>
            </Modal.Body>

            <Modal.Footer style={{ display: "flex", justifyContent: "center"}}>
                <Button
                    variant="primary"
                    onClick={handleClose}
                    className="p-25"
                    >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
